import { memo } from 'react';
import { AssistantMessagePartWithDetails } from '~/components/chat/assistant-message/AssistantMessagePartWithDetails';
import { useDetailsDialog } from '~/components/chat/assistant-message/context';
import { usePartsWithId } from '~/components/chat/assistant-message/hooks/useProcessedParts';
import { Dialog, DialogContent, DialogHeader } from '~/components/ui/Dialog';
import type { Message } from '~/types/chat';

interface AssistantMessageDetailsDialogProps {
  message?: Message;
}

export const AssistantMessageDetailsDialog = memo(({ message }: AssistantMessageDetailsDialogProps) => {
  const { isDetailsDialogOpen, closeDetailsDialog } = useDetailsDialog();
  const partsWithId = usePartsWithId(message?.parts);

  return (
    <Dialog
      open={isDetailsDialogOpen}
      onClose={closeDetailsDialog}
      maxWidth={500}
      contentClassName="grid grid-rows-[auto_1fr]"
    >
      <DialogHeader title="Details" />
      <DialogContent className="overflow-y-auto grid gap-4">
        {partsWithId.map((part) => (
          <AssistantMessagePartWithDetails key={part.id} part={part} />
        ))}
      </DialogContent>
    </Dialog>
  );
});
